var isUsingOneTrust = function isUsingOneTrust() {
  return !!document.querySelector("script[src*='cdn.cookielaw.org']");
};

export default isUsingOneTrust;